import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs"
import { useTranslation } from "react-i18next"
import { usePermissions } from "@/auth/PermissionsContext"

interface ProductTabsProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
  handleResetSearch?: () => void;
  hasReferralProducts?: boolean;
}

export const ProductTabs = ({
  activeTab,
  onTabChange,
  handleResetSearch,
  hasReferralProducts = false,
}: ProductTabsProps) => {
  const { t } = useTranslation('common');
  const { hasPermission } = usePermissions();

  const canViewByRole = hasPermission('products.view_products_by_role');

  const allTabs = [
    { value: 'products', label: t('tabProducer'), visible: true },
    { value: 'coproducers', label: t('tabCoProducer'), visible: canViewByRole },
    { value: 'affiliates', label: t('tabAffiliate'), visible: canViewByRole },
    {
      value: 'referral_links',
      label: t('tabReferralLinks'),
      visible: hasReferralProducts && hasPermission('partner_indications.view_partner_indications'),
    },
  ];

  const tabs = allTabs.filter((tab) => tab.visible);

  return (
    <Tabs value={activeTab} onValueChange={onTabChange} className="w-full min-w-0">
      <div className="w-full min-w-0 overflow-x-auto [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        <TabsList className="inline-flex w-max min-w-full md:min-w-0 md:w-auto h-auto gap-1.5 sm:gap-2 bg-[#18181B] p-1 rounded-full">
          {tabs.map((tab) => (
            <TabsTrigger
              key={tab.value}
              value={tab.value}
              data-cy={`tab-${tab.value}`}
              onClick={handleResetSearch}
              className="shrink-0 px-3 sm:px-4 py-1.5 text-xs sm:text-sm rounded-full data-[state=active]:bg-[#27272A] data-[state=active]:text-white"
            >
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>
      </div>
    </Tabs>
  );
};
